export default class Footer{
	constructor(){
		const wholefooter = document.querySelector(".footer");
		const footer = document.querySelector(".footer__main");
		const footerBg = footer.querySelector(".footer__main__bg");
		const footerBgVideo = footer.querySelector(".footer__main__bg video");
		const footerContainer = footer.querySelector(".footer__main__container");
		const footerCatchcopy = footer.querySelector(".footer__main__catch");

		gsap.fromTo(footerBgVideo, {
			yPercent: -50
		},{ 
			yPercent:  0,
			ease: "none",
			scrollTrigger: { 
				trigger: footer,
				start: "top bottom",
				end: "top top",
				scrub: true,
				invalidateOnRefresh: true
			}
		});
		ScrollTrigger.create({
			trigger: footerBg,
			start: "top top",
			endTrigger: footer,
			end: "bottom bottom",
			pin: true,
		});
		ScrollTrigger.create({
			trigger: footerCatchcopy,
			start: "top 80%",
			onEnter:     ()=>{ footerCatchcopy.classList.add("appear"); },
			onLeaveBack: ()=>{ footerCatchcopy.classList.remove("appear"); },
		});

		let footerBgInitialized = false;
		const footerBgVideoTrigger = ScrollTrigger.create({
			trigger: wholefooter,
			start: "top bottom",
			onEnter: ()=>{
				if(!footerBgInitialized){
					footerBgVideo.setAttribute("src", footerBgVideo.getAttribute("data-src"));
					footerBgVideo.addEventListener("canplaythrough", ()=>{ footerBgVideo.play() }, {once: true});
					footerBgVideo.load();
					footerBgVideo.play();
					footerBgInitialized = true;
					footerBgVideoTrigger.kill();
				}
			}
		});


		// ロゴスクロール
		const related = footer.querySelector(".footer__main__related");
		const container = related.querySelector(".footer__main__related__container");
		const minSpeed = 0.05;
		const maxSpeed = 0.3;
		const spLogoAreaWidth = 1120;
		const pcLogoAreaWidth = 1920;
		let groupWidth = ((window.currentContext == "sp") ? spLogoAreaWidth : pcLogoAreaWidth) / 10; //rem換算
		let targetSpeed = minSpeed;
		let speed = minSpeed;
		let posX = 0;
		let direction = true;
		let isMouseOn = false;
		let request = null;
		const update = ()=>{
			groupWidth = ((window.currentContext == "sp") ? spLogoAreaWidth : pcLogoAreaWidth) / 10; //rem換算
			speed += (targetSpeed - speed)/10;
			posX += speed;
			if(posX >= groupWidth) posX = posX-groupWidth;
			if(posX <= groupWidth*-1) posX = posX+groupWidth;
			
			container.style.transform = "translateX("+(posX*-1)+"rem)";
			request = requestAnimationFrame(update);
		}
		const pause = () =>{
			if(request) cancelAnimationFrame(request);
		}
		update();

		if(window.isTouch){
			let dragStartX = 0;
			let dragStartY = 0;
			let dragLastX = 0;
			let dragLastY = 0;
			let dragLastX2 = 0;
			let dragLastY2 = 0;
			let dragActive = null;
			let dragging = false;
			let startPos = 0;
			let endPos = 0;
			function dragStart(x,y,e){
				if(window.currentContext == "pc") return;
				pause();
				dragStartX = x;
				dragStartY = y;
				dragLastX = x;
				dragLastY = y;
				dragLastX2 = x;
				dragLastY2 = y;
				dragActive = null;
				dragging = true;
				startPos = posX;
				container.classList.add("dragging");
			}
			function dragMove(x,y,e){
				if(window.currentContext == "pc") return;
				if(!dragging) return;
				if(dragActive === null){
					if(Math.abs(dragStartX-x) > Math.abs(dragStartY-y)){
						dragActive = true;
					}else{
						dragActive = false;
					}
					if(!window.isTouch) dragActive = true;
				}
				if(dragActive !== true) return false;
				endPos = ((x-dragStartX)/-10)+posX;
				if(x-dragStartX > 0){
					if(endPos >= groupWidth) endPos = endPos-groupWidth;
				}else{
					if(endPos <= groupWidth*-1) endPos = endPos+groupWidth;
				}
				container.style.transform = "translateX("+(endPos*-1)+"rem)";
				dragLastX2 = dragLastX;
				dragLastY2 = dragLastY;
				dragLastX = x;
				dragLastY = y;
				e.preventDefault();
			}
			function dragEnd(x,y,e){
				if(window.currentContext == "pc") return;
				if(!dragging) return;
				container.classList.remove("dragging");
				dragging = false;
				if(dragActive) posX = endPos;
				speed = (dragLastX2-dragLastX)/8.5;
				update();
			}
			container.addEventListener("touchstart", (e)=>{
				if(e.changedTouches){
					dragStart(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragStart(e.pageX,e.pageY,e);
				}
			}, false);
			container.addEventListener("touchmove", (e)=>{
				if(e.changedTouches){
					dragMove(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragMove(e.pageX,e.pageY,e);
				}
				if(dragActive){
					return false;
				}
			}, false);
			container.addEventListener("touchleave", (e)=>{
				if(e.changedTouches){
					dragEnd(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragEnd(e.pageX,e.pageY,e);
				}
			}, false);
			container.addEventListener("touchend", (e)=>{
				if(e.changedTouches){
					dragEnd(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragEnd(e.pageX,e.pageY,e);
				}
			}, false);
		}else{
			const mousemove = (e)=>{
				const pos = Math.max(0, Math.min(window.innerWidth, e.clientX));
				const amount = (pos-window.innerWidth/2)/(window.innerWidth/2);
				direction = amount>0;
				targetSpeed = maxSpeed*amount*Math.abs(Math.pow(amount,2));
				isMouseOn = true;
			}
			const mouseleave = ()=>{
				if(direction){
					targetSpeed = minSpeed;
				}else{
					targetSpeed = minSpeed*-1;
				}
				isMouseOn = false;
			}
			related.addEventListener("mousemove", mousemove, false);
			related.addEventListener("mouseleave", mouseleave, false);
		}
	}
}